<template>
  <div :class="{ 'layout-taps-padding': showActive, 'layout-taps-wrap': true }" :style="tapsStyle">
    <el-breadcrumb separator="/">
      <template v-for="(item, index) in routes">
        <el-breadcrumb-item v-if="!item.path"  :key="index" >{{ $t(item.meta.title) }}</el-breadcrumb-item>
        <el-breadcrumb-item v-else-if="index === routes.length-1"  :key="index" >{{ $t(item.meta.title) }}</el-breadcrumb-item>
        <el-breadcrumb-item v-else :key="index" :to="{ path: item.path }" >{{ $t(item.meta.title) }}</el-breadcrumb-item>
      </template>
    </el-breadcrumb>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import s from 'storejs'
const rootRoute = {
  path: '/dashboard',
  name: 'Dashboard',
  meta: { title: '1108', icon: 'dashboard' }
}
export default {
  data() {
    return {
      showActive: true, // 是否展示控制按钮
      translate: 0, // 滚动位置
      step: 300, // 移动步长
      animate: false
    }
  },
  watch: {
    $route(to, form) {
      this.$nextTick(() => {
        // 路由跳转判断是否存在列表中
        this.handlerRecord(to, form)
      })
    }
  },
  computed: {
    ...mapGetters({
      routes: 'accessRecord',
      permissionRoutes: 'routes',
      sidebar: 'sidebar'
    }),
    isCollapse() {
      return !this.sidebar.opened
    },
    // 计算宽度
    navWidth() {
      return this.isCollapse ? 48 : 216
    },
    tapsStyle() {
      const { navWidth } = this
      return { left: `${navWidth}px`, width: `calc(100% - ${navWidth}px)` }
    },
    currentIndex() {
      return this.routes.findIndex(item => item.path === this.$route.path)
    }
  },
  mounted() {
    this.init()
    // window.addEventListener(
    //   'resize',
    //   this.$util.debounce(() => {
    //     this.resize()
    //   }, 500)
    // )
  },
  methods: {
    init() {
      // const routes = s.get('accessRecord') || []
      // // 获取历史访问数据
      // this.handlerGetStorageDataForSaveStore(routes)
      // this.initHistoryAccess()
      // 是否包含当前路由
      this.$nextTick(() => this.handlerRecord(this.$route))
    },
    // 初始化组件读取localStorage中的历史记录
    // 根据用户权限筛选出最新的
    initHistoryAccess() {
      // // 本地存储的访问记录
      const accessRecord = localStorage.getItem('accessRecord') || '[]'
      const historyRoutes = JSON.parse(accessRecord)
      // 更新store到全局
      this.handlerGetStorageDataForSaveStore(historyRoutes)
    },
    /**
     *   判断路由列表中是否存在当前路由 无则添加
     *   之后跳转到可视区域
     *   @parma { Object } to 目标路由
     */
    handlerRecord(to, form) {
      const { path, meta, query } = to
      // 判断是否包含当前路由
      const findIndex = this.routes.findIndex(item => item.path === path)
      const isInclude = this.routes.some(item => item.path === path)
      if (!to && isInclude) return this.$nextTick(() => {})
      let typeForm = ''
      let pathForm = ''
      let formIndex = -1
      if (form) {
        typeForm = form.meta.type
        pathForm = form.path
        formIndex = this.routes.findIndex(item => item.path === form.path)
      }

      let newRoutes = []
      if (findIndex !== -1) {
        // findIndex不为-1，删除后面路由
        newRoutes = this.routes.slice(0, findIndex + 1)
      } else {
        // from.path 和 to.meta.type 相等说明为父子关系
        if (pathForm === meta.type) {
          newRoutes = [...this.routes, { path, meta, query }]
        } else if (typeForm === meta.type) {
          // from.meta.type和to.meta.type相等说明是兄弟关系
          this.routes.splice(formIndex, 1)
          newRoutes = [...this.routes, { path, meta, query }]
        } else {
          newRoutes = [{ path, meta, query }]
        }
      }
      // 当前只有一层路由 获取第一层路由信息
      if (newRoutes.length === 1 && path !== '/dashboard') {
        const all = []
        const deepScreen = (routes) => {
          const deepFun = (routes) => {
            if (!routes) return
            return routes.filter(item => {
              if (meta && meta.module) {
                const module = meta.module.split(',')
                module.forEach(mod => {
                  if (item.name === mod && mod !== path) {
                    all.push(item)
                  }
                })
              }
              return deepFun(item.children)
            })
          }
          return deepFun(routes)
        }
        deepScreen(this.permissionRoutes)
        if (all.length) {
          all.reverse().forEach(item => {
            newRoutes.unshift({
              path: item.meta.module ? item.name : '',
              meta: item.meta
            })
          })
        }
      }
      this.$nextTick(() => {
        this.handlerGetStorageDataForSaveStore(newRoutes)
      })
    },
    /**
     *  获取或者存储路由数据
     *  @param { Object } routes 路由列表
     *  @param { Boolean } state 是否跳转可视区域
     */
    handlerGetStorageDataForSaveStore(routes, state) {
      // 没有路由时添加默认路由
      const isInclude = routes.some(item => item.path === '/dashboard')
      if (!isInclude && !routes.length) {
        routes.unshift(rootRoute)
      }
      s.set('accessRecord', routes)
      this.$store.dispatch('permission/setAccessRecord', routes)
    }
  }
}
</script>
